import {Injectable} from '@angular/core';
import {GlobalEventDispatcherService} from "../shared/services/global-event-dispatcher/global-event-dispatcher.service";
import {RequesterService} from "../shared/services/requester/requester.service";
import {Router} from "@angular/router";
import {DbStoreState} from '../store/reducers';
import {Store} from '@ngrx/store';
import * as fromStore from '../store';
import {CookieService} from "ngx-cookie";
import {GoogleAnalyticsService} from "../shared/services/google-analytics/google-analytics.service";
import {UserService} from "../user/user.service";


@Injectable()
export class ExternalApiService {

  private _isTokenRefreshing: boolean;
  private currentWorkspaceId: any;
  private ownerWorkspaceId: any;

  constructor(
    private _router: Router,
    private _store: Store<DbStoreState>,
    private _globalEventDispatcher: GlobalEventDispatcherService,
    private _cookieService: CookieService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _userService: UserService,
    private _requester: RequesterService,
  ) {
    this._isTokenRefreshing = false;
    this._store.select(fromStore.getWorkspaceIdEntities).subscribe( workspaceIdEntities => {
      this.ownerWorkspaceId = workspaceIdEntities.ownerWorkspaceId;
      this.currentWorkspaceId = workspaceIdEntities.currentWorkspaceId || this.ownerWorkspaceId;
    });

  }



}
